module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/exam-a8f5a6.svg";